import React from 'react';

import { MuiIcon, Props as MuiIconProps } from 'components/common/Icons/base/MuiIcon/MuiIcon';

interface Props extends MuiIconProps {
    isActive: boolean;
}

export const StarIcon = ({ isActive, fontSize = '3rem', ...props }: Props) => {
    const icon = isActive ? 'star' : 'star_border';
    const color = isActive ? 'var(--fg-brand-secondary_hover)' : '#7c838c';
    return <MuiIcon icon={icon} fontSize={fontSize} color={color} type={'round'} {...props} />;
};
